<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  firstName: { type: String, default: '' },
  newServices: { type: Number, default: 0 },
});

const emit = defineEmits(['dismiss']);
const { t } = useI18n();
</script>

<template>
  <section
    class="rounded-lais border border-lais-primary/20 bg-white p-4 text-sm text-lais-text-body shadow-lais-card"
  >
    <div class="flex items-center justify-between gap-4">
      <div class="flex min-w-0 items-center gap-3">
        <img
          src="~dashboard/assets/images/nucleo-welcome.png"
          alt=""
          class="hidden size-14 shrink-0 object-contain sm:block"
        />
        <div class="min-w-0">
          <p class="font-semibold text-lais-text">
            {{ t('NUCLEO_WORK_ORDERS.WELCOME', { name: firstName }) }}
          </p>
          <p class="text-sm text-lais-text-muted">
            {{ t('NUCLEO_WORK_ORDERS.NEW_SERVICES_PREFIX') }}
            <strong class="font-bold text-lais-text">
              {{ newServices }}
            </strong>
            {{ t('NUCLEO_WORK_ORDERS.NEW_SERVICES_SUFFIX') }}
          </p>
        </div>
      </div>
      <button
        type="button"
        class="grid size-8 shrink-0 place-items-center rounded-full text-lais-text-muted transition hover:bg-lais-bg-soft hover:text-lais-text"
        :aria-label="t('NUCLEO_WORK_ORDERS.ACTIONS.DISMISS_NOTICE')"
        @click="emit('dismiss')"
      >
        <span class="i-lucide-x size-4" aria-hidden="true" />
      </button>
    </div>
  </section>
</template>
